"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RecipientType_1 = require("owa-recipient-common/lib/store/schema/RecipientType");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
function getRecipientString(recipientType) {
    switch (recipientType) {
        case RecipientType_1.RecipientType.To:
            return owa_common_strings_1.default.ToRecipientLabel;
        case RecipientType_1.RecipientType.Cc:
            return owa_common_strings_1.default.CcRecipientLabel;
        case RecipientType_1.RecipientType.Bcc:
            return owa_common_strings_1.default.BccRecipientLabel;
        default:
            throw new Error("There is no localized string for RecipientType." + RecipientType_1.RecipientType[recipientType]);
    }
}
exports.default = getRecipientString;
//# sourceMappingURL=getRecipientString.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/utils/getRecipientString.js
// module id = 3184
// module chunks = 2 3